import { getApiBaseUrl } from "./auth";

/**
 * PocketBase-style file URL: `/api/files/{collection}/{recordId}/{fileName}`.
 *
 * @param {{ collectionName: string, recordId: string, fileName?: string | null }} input
 * @returns {string} Absolute URL, or empty string if URL cannot be built.
 */
export function resolveCollectionFileUrl({ serverUrl, collectionName, recordId, fileName }) {
  const trimmed = fileName?.trim() ?? "";
  if (!trimmed) return "";
  if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {
    return trimmed;
  }
  const base = serverUrl || getApiBaseUrl();
  if (!base) return "";
  const coll = encodeURIComponent(collectionName);
  const rid = encodeURIComponent(recordId);
  const fname = encodeURIComponent(trimmed);
  return `${base}/files/${coll}/${rid}/${fname}`;
}
